module.exports = __webpack_public_path__ + "img/appAsset-brand--GoogleSheets.ad9df3c3.svg";